import React from "react";
import {
  Alert,
  AlertTitle,
  AlertProps as MuiAlertProps,
} from "@material-ui/lab";
import { IconClose, MUIBox, tokens } from "@cobee/cobee-ui";
import { useStyles } from "./styles";
import CobeeLink, { CobeeLinkProps } from "../CobeeLink";

interface AlertProps extends MuiAlertProps {
  title?: string;
  actionButtonsProps?: CobeeLinkProps[];
}

export default function CobeeAlert({
  children,
  title,
  severity = "info",
  onClose,
  actionButtonsProps,
  ...props
}: AlertProps) {
  const classes = useStyles();
  const [visible, setVisible] = React.useState(true);

  return visible ? (
    <Alert severity={severity} className={classes.alert} {...props}>
      <MUIBox className={classes.innerContainer}>
        <MUIBox className={classes.text}>
          {title ? (
            <AlertTitle className={classes.alertTitle}>{title}</AlertTitle>
          ) : null}
          {children}
        </MUIBox>

        <MUIBox className={classes.actionsContainer}>
          <IconClose
            size={24}
            className={classes.closeBtn}
            onClick={onClose || (() => setVisible(false))}
            color={tokens.palette.grey.A700}
          />
          <MUIBox className={classes.actionButtonsContainer}>
            {actionButtonsProps?.map((buttonProps) => (
              <CobeeLink
                key={`alert-${title}-button`}
                {...buttonProps}
                className={classes.link}
              />
            ))}
          </MUIBox>
        </MUIBox>
      </MUIBox>
    </Alert>
  ) : null;
}
